import { render, staticRenderFns } from "./ClearStroage.vue?vue&type=template&id=388d0186&"
import script from "./ClearStroage.vue?vue&type=script&lang=js&"
export * from "./ClearStroage.vue?vue&type=script&lang=js&"
import style0 from "./ClearStroage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports